import React from "react";
import { CTA_TYPE, CTA_SIZE } from "../../../data/constants";
import CtaComponent from "../../../components/reusable-ui/cta";
import CustomTabSwitch from "../../../components/reusable-ui/material-ui-comp/custom-tab-switch";
import { XML_REPORT_TYPES_LIST } from "../../../data/accounting-constants";
import { ALL_FEATURE_TYPES_MAP } from "../../../data/user-features-constants";
import { isFeatureAllowed } from "../../../helpers/common-helper";

type Props = {
  mappedBranches?: any[];
  toggleGenerateModal: () => void;
  canGenerate: boolean;
  selectedTab: string;
  handleTabClick: (value: string) => void;
};

const Header = (props: Props) => {
  const {
    mappedBranches = [],
    toggleGenerateModal,
    canGenerate,
    selectedTab,
    handleTabClick,
  } = props;
  return (
    <div className="flex pt-18 pb-[21px] items-center px-[63px] border-b-[1px] border-[]">
      <div className="flex items-center">
        <div className="text-[#404040] text-20 font-bold mr-16">
          {mappedBranches?.length > 0 ? "Mapped Data" : "Create New Mapping"}
        </div>
        <CustomTabSwitch
          preSelectedValue={selectedTab}
          tabOptionsList={XML_REPORT_TYPES_LIST}
          onTabClick={handleTabClick}
        />
      </div>
      {isFeatureAllowed(
        ALL_FEATURE_TYPES_MAP.ALLOW_DOWNLOAD_XML_LEDGER_REPORT
      ) && (
        <CtaComponent
          customClass="ml-auto"
          ctaSize={CTA_SIZE.medium}
          onCtaClick={toggleGenerateModal}
          ctaType={CTA_TYPE.active_cta}
          isDisabled={!canGenerate}
          ctaText="Generate XML"
        />
      )}
    </div>
  );
};
export default Header;
